import { InjectButtonParams } from '../utils/oldNavigation.utils';

export const INJECT_VIDEO_LOGO = 'inject video logo';
export interface InjectVideoLogoParams {
    videoPath: string;
}
export const injectVideoLogo = (params: InjectVideoLogoParams) => {
    const { videoPath } = params;
    return {
        type: INJECT_VIDEO_LOGO,
        videoPath,
    };
};

export const INJECT_BUTTON_TO_MENU = 'inject button to menu';
export const injectButtonToMenu = (params: InjectButtonParams) => {
    const { onClick, text } = params;
    return {
        type: INJECT_BUTTON_TO_MENU,
        onClick,
        text,
    };
};
